<template>
    <div class="policy-child-page">
        <PolicyHistoryFab
            ref="historyFab"
            panel-title="儿童隐私政策 · 历史版本"
        >
            <ul class="policy-child-page__panel-list">
                <li
                    v-for="item in versions"
                    :key="item.id"
                >
                    <button
                        type="button"
                        class="policy-child-page__panel-btn"
                        :class="{'policy-child-page__panel-btn--active': item.id === activeId}"
                        @click="selectVersion(item.id)"
                    >
                        <span class="policy-child-page__panel-btn-title">{{item.title}}</span>
                        <span class="policy-child-page__panel-btn-sub">{{item.subtitle}}</span>
                    </button>
                </li>
            </ul>
        </PolicyHistoryFab>

        <keep-alive>
            <component
                :is="resolvedComponent"
                v-if="resolvedComponent"
                :key="activeId"
            />
        </keep-alive>
    </div>
</template>

<script>
import PolicyHistoryFab from '@/components/PolicyHistoryFab.vue';
import {POLICY_CHILD_VERSIONS, resolveChildPolicyVersionId} from './policyChildVersions';

export default {
    name: 'PolicyChildPage',
    components: {
        PolicyHistoryFab,
    },
    data() {
        return {
            // 只放展示字段：组件对象不进 data，避免被 reactive 深度代理
            versions: POLICY_CHILD_VERSIONS.map(({id, title, subtitle}) => ({id, title, subtitle})),
            activeId: resolveChildPolicyVersionId(this.$route.query.v),
        };
    },
    computed: {
        // component 已在版本清单里包装为稳定的异步组件，此处直接取用
        // （不要在这里现包装，否则 <keep-alive> 缓存无法命中）
        resolvedComponent() {
            const entry = POLICY_CHILD_VERSIONS.find(x => x.id === this.activeId);
            return entry ? entry.component : null;
        },
    },
    watch: {
        '$route.query.v': {
            handler() {
                this.activeId = resolveChildPolicyVersionId(this.$route.query.v);
            },
        },
    },
    mounted() {
        document.title = '儿童隐私政策';
    },
    methods: {
        defaultVersionId() {
            const row = POLICY_CHILD_VERSIONS.find(x => x.isDefault);
            return row ? row.id : POLICY_CHILD_VERSIONS[0].id;
        },
        selectVersion(id) {
            if (this.$refs.historyFab) {
                this.$refs.historyFab.close();
            }
            const query = id === this.defaultVersionId() ? {} : {v: id};
            this.$router.replace({path: '/policychild', query});
        },
    },
};
</script>

<style src="./policyChildDoc.css"></style>

<style scoped>
.policy-child-page {
    position: relative;
    min-height: 100vh;

    padding-bottom: 24px;
    background: #fff;
    --policy-fab-top: 8px;
    --policy-fab-z: 1001;
}

.policy-child-page__panel-list {
    margin: 0;
    padding: 0;
    list-style: none;
    max-height: 208px;
    overflow-y: auto;
}

.policy-child-page__panel-list:last-child {
    margin-bottom: 0;
}

.policy-child-page__panel-btn {
    display: block;
    width: 100%;
    margin-bottom: 8px;
    padding: 8px 10px;
    text-align: left;
    background: #f7f8fa;
    border: 1px solid #e8e8e8;
    border-radius: 8px;
    cursor: pointer;
}

.policy-child-page__panel-btn--active {
    border-color: #3370ff;
    background: #eef3ff;
}

.policy-child-page__panel-btn-title {
    display: block;
    font-size: 13px;
    font-weight: 600;
    color: #333;
}

.policy-child-page__panel-btn-sub {
    display: block;
    margin-top: 4px;
    font-size: 11px;
    line-height: 1.4;
    color: #666;
}
</style>
